import React, { Component } from 'react'
import PlayerCard from './Components/PlayerCard'
import './_styles.scss'
import Device from '../../../../../../../../../devices/device'
import { getNodeCode } from '../../../../../../../utils'
import Utils from '../../../../../../../../../utils/Utils'
import { add } from 'date-fns'
import { addFavoriteTeam } from '../../../../../../../services/addFavoriteTeam'
import { deleteFavoriteTeam } from '../../../../../../../services/deleteFavoriteTeam'
import { STAR_EMPTY, STAR_FILLED } from '../../../../../../constants'
import Translator from '../../../../../../../../../requests/apa/Translator'
import Asset from '../../../../../../../../../requests/apa/Asset'
import logger from 'src/utils/logger/logger';

class CountryDetailsCenter extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isFavorited: undefined
    }
    this.keys = Device.getDevice().getKeys()

    const code = getNodeCode()
    const metadataValue = Utils.getApaMetadataKey('sports_competition_config', null)
    this.idLeague = metadataValue && metadataValue[code] ? metadataValue[code].leagueId : null
  }

  componentDidUpdate(prevProps) {
    // Inicializar el estado de favorito con la prop recibida del padre (dataHeader.isFavorited)
    if (prevProps.isFavorited !== this.props.isFavorited) {
      this.setState({ isFavorited: this.props.isFavorited })
    }
  }

  handleFavoriteKeyDown = async (e) => {
    if (this.keys.getPressKey(e.keyCode) === 'DOWN') {
      e.preventDefault()
      e.stopPropagation()
      var mainMenuTab = document.querySelector('.country-details-body__tabs .focusable')
      // var mainMenuTab = activeText ? activeText.closest('.focusable') : null
      if (mainMenuTab) mainMenuTab.focus()
      return
    }
    if (this.keys.getPressKey(e.keyCode) === 'LEFT') {
      e.preventDefault()
      e.stopPropagation()
      var btn = document.querySelector('#btnCountryDetailsBack')
      if (btn) btn.focus()
      return
    }
    if (this.keys.getPressKey(e.keyCode) === 'OK') {
      e.preventDefault()
      e.stopPropagation()
      await this.toggleFavorite()
    }
  }

  toggleFavorite = async () => {
    try{
      const { countryId } = this.props
      const { isFavorited } = this.state
      if (!isFavorited) {
        await addFavoriteTeam(countryId, this.idLeague)
      } else {
        await deleteFavoriteTeam(countryId, this.idLeague)
      }
      this.setState(
        (prev) => { return { isFavorited: !prev.isFavorited } },
        () => {
          this.props.onClickFavorite && this.props.onClickFavorite(countryId, this.state.isFavorited) // callback para actualizar estado de favoritos en el padre (CountryDetailsModal) y que se refleje en la CountryCard
        }
      )
    }catch(error){
      logger.error('Error toggling favorite team:', error);
    }
  }



  render () {
    const isFavorited = this.state.isFavorited;

    return (
      <div className='country-details-header__center'>
          <div className='country-details-header__favorite-country-wrapper' tabIndex={0} onKeyDown={this.handleFavoriteKeyDown}>
              <div className='country-details-header__favorite-country-img-wrapper'>
                  <img className='country-details-header__favorite-country-img' src={Asset.get(isFavorited ? STAR_FILLED : STAR_EMPTY)} alt='' />
              </div>
              <p className='country-details-header__favorite-country-label'>{Translator.get(isFavorited ? 'eventodeportivo_texto_agregarfavorito' : 'eventodeportivo_texto_quitarfavorito')}</p>
          </div>
          <div className='country-details-header__featured-players-wrapper'>
              { this.props.featuredPlayers && this.props.featuredPlayers.length > 0 && <p className='country-details-header__featured-players-label'>{Utils.cutPlayerString(Translator.get('eventodeportivo_paises_fichasuperior_texto_titulo_jugadoresdestacados'), 30)}</p> }
              <div className='country-details-header__featured-players'>
                {this.props.featuredPlayers && this.props.featuredPlayers.map((player, index) => (
                  <PlayerCard
                    key={player.playerId}
                    name={player.playerName}
                    photoUrl={player.playerImage}
                    subtitle={player.playerPosition}
                    statLabel={player.headline}
                    statValue={player.playerValue}
                    color={this.props.color}
                    isLast={index === this.props.featuredPlayers.length - 1}
                  />
                ))}
              </div>
          </div>
      </div>
    )
  }
}

export default CountryDetailsCenter



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/Paises/components/CountryDetailsModal/Components/CountryDetailsHeader/Components/CountryDetailsCenter/index.jsx